import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import HeaderInner from "../../Components/HeaderInner";
import Carosle from "../../Components/Carosle";
import SpaServicesList from "../../Components/SpaServicesList";
import { ShowSPA } from "../../API/SPAAPI";
import { useBusinessNameContext } from "./../../context/BusinessName";
import CustomBusinessServiceLoader from "../../Components/Loaders/CustomBusinessServiceLoader";
import { trackCategoryViewed } from "../../utils/mixpanel";

function SpaCategory() {
  const { businessName } = useBusinessNameContext();

  const navigate = useNavigate();
  const params = useParams();
  const room_uuid = params.room_uuid;
  const spa_uuid = params.spa_uuid;
  const category_id = params.category_id;
  const lang = localStorage.getItem("lang");

  let spa;
  let images;
  let bgColor;
  let color;
  let text;
  let category;
  let categoryServices;
  const { data, isLoading, error } = ShowSPA(room_uuid, spa_uuid, lang);

  if (!isLoading) {
    if (error) {
      if (error?.response.status == 404) {
        navigate(`/not-found`);
      }
    } else {
      if (data.data.status === false) {
        navigate(`/${room_uuid}/qr-scan`);
      } else {
        spa = data.data.data.spa;
        images = spa?.header_images;
        color = data.data.data.color;
        bgColor = data.data.data.header_color;
        category = spa.categories?.find(
          (item) => String(item.id) === String(category_id),
        );
        categoryServices = category?.services;
        text = category?.name || data.data.data.header_title;

        if (!category) {
          navigate(`/${room_uuid}/spa/${spa_uuid}`, { replace: true });
        }
      }
    }
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  useEffect(() => {
    if (!isLoading && !error && category) {
      trackCategoryViewed({
        category_id: category.id,
        category_name: category.name || "",
        category_type: "spa",
      });
    }
  }, [isLoading, category?.id]);

  return (
    <>
      <HeaderInner bgColor={bgColor} color={color} headerName={text} />
      <main className="home-main bg-white back-white pad-top-0 pb-30">
        {isLoading ? (
          <CustomBusinessServiceLoader
            businessName={businessName}
            loader={"spa"}
          />
        ) : (
          <>
            <Carosle className={"dot-bar"} headerImages={images} />
            <SpaServicesList
              services={categoryServices}
              room_uuid={room_uuid}
              spa_uuid={spa_uuid}
              category_id={category_id}
            />
          </>
        )}
      </main>
    </>
  );
}
export default SpaCategory;
